module.exports = __webpack_public_path__ + "static/media/abrakadabra.672f1080.mp3";